import React from 'react';
import Loading from 'components/pure/utils/Loading';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import ScorecardForm from './ScorecardForm';
import ScorecardFormDialogHelp from './ScorecardFormDialogHelp';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import {is} from 'immutable';
import {required} from 'records/Scorecard';
import {unsavedMessage} from 'utils/const';
import {validate as validateQuestion} from 'records/Question';
import './ScorecardFormDialog.styl';

export default class ScorecardFormDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSave = this.onSave.bind(this);
  }

  onSave() {
    const {scorecard} = this.props.EditScorecardStore;
    const action = scorecard.id === null ? 'create' : 'update';
    this.props.AdminScorecardActions[action + 'Scorecard'](scorecard);
  }

  hasError() {
    const {scorecard} = this.props.EditScorecardStore;
    const isBlank = value => (value || '').trim() === '';
    return (
      required.some(property => isBlank(scorecard[property])) ||
      scorecard.questions.some(validateQuestion)
    );
  }

  render() {
    const {scorecard, initialScorecard, isLoading, wasErrorFetching, isSaving} =
      this.props.EditScorecardStore;

    const onRequestClose = !is(scorecard, initialScorecard)
      ? () => confirm(unsavedMessage).then(this.props.onRequestClose, noop)
      : this.props.onRequestClose;

    return (
      <Dialog
        title={(scorecard && scorecard.id ? 'Edit' : 'Create') + ' Scorecard'}
        className="scorecard-form-dialog"
        autoScrollBodyContent={true}
        closeButton={true}
        actions={[
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            onClick={this.onSave}
            disabled={isSaving || isLoading || wasErrorFetching || this.hasError()}>
            Save
          </Button>,
          <Button variant="outlined" className="ev-button" onClick={onRequestClose}>
            Cancel
          </Button>,
        ]}
        open={true}
        onRequestClose={onRequestClose}>
        <ScorecardFormDialogHelp />
        {wasErrorFetching ? (
          'Error fetching scorecard.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <ScorecardForm
            scorecard={scorecard}
            onChange={this.props.EditScorecardActions.updateForm}
            CardReasonEditStore={this.props.CardReasonEditStore}
            CardReasonEditActions={this.props.CardReasonEditActions}
            CardReasonActions={this.props.CardReasonActions}
            currentUser={this.props.currentUser}
          />
        )}
      </Dialog>
    );
  }
}
